import { BaseResource } from './base-resource';

export class Invitation extends BaseResource {
  name: string;
  email: string;
}
